import React, { useState, useEffect } from "react";
import { FcApprove, FcDisapprove } from "react-icons/fc";
import "./WallentPendding.css";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Modal from "./Modal";
import Spinner from "../../../../screens/Spin/Spinner";
import {
  approvePenddingSettlement,
  getAllPenddingSettlement,
  getUser,
} from "../../../../config/LiveApi";

const PenddingForm = () => {
  const token = useSelector((store) => store.userReducer.token);
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [user, setUser] = useState([]);
  const [modalData, setModalData] = useState({
    isOpen: false,
    tnxId: null,
    status: null,
  });

  const getWalletData = async () => {
    setIsLoading(true);
    try {
      const response = await getAllPenddingSettlement(token);
      setTableData(response.data);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const getAllUser = async () => {
    setIsLoading(true);
    try {
      const response = await getUser(token);
      setUser(response.data);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      getAllUser();
      getWalletData();
    }
  }, [token]);

  const getUserNameById = (id) => {
    const foundUser = user.find((u) => u.id === id);
    return foundUser ? foundUser.alias || foundUser.id : "-";
  };

  const handleAction = (tnxId, status) => {
    setModalData({ isOpen: true, tnxId, status });
  };

  const handleConfirm = async () => {
    setModalData({ isOpen: false, tnxId: null, status: null });
    setIsLoading(true);
    try {
      const payload = {
        status: modalData.status,
        tnxId: modalData.tnxId,
      };
      const res = await approvePenddingSettlement(token, payload);
      toast.success(res.message || "Updated successfully!");
      await getWalletData();
    } catch (err) {
      toast.error("Failed to update status.");
    } finally {
      setModalData({ isOpen: false, tnxId: null, status: null });
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setModalData({ isOpen: false, tnxId: null, status: null });
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), 300);
  };
const handleApproveAll = async () => {
  // Step 1: Filter only ROLLING and not already SUCCESS
  const rollingPending = tableData.filter(
    (transaction) =>
      transaction.remark?.startsWith("ROLLING") &&
      transaction.status !== "SUCCESS"
  );

  if (rollingPending.length === 0) {
    toast.info("No pending rolling settlements to approve.");
    return;
  }

  // Step 2: Remove duplicate tnxId
  const uniqueTransactions = Array.from(
    new Map(
      rollingPending.map((item) => [item.tnxId, item])
    ).values()
  );

  setIsLoading(true);

  try {
    // Step 3: Approve unique only
    for (const transaction of uniqueTransactions) {
      await approvePenddingSettlement(token, {
        status: "SUCCESS",
        tnxId: transaction.tnxId,
      });
    }

    toast.success("All rolling reserve settlements approved successfully!");
    await getWalletData();
  } catch (err) {
    toast.error("Failed to approve rolling settlements.");
  } finally {
    setIsLoading(false);
  }
};

  return (
    <div className="pendding-report-table-container">
      <div className="user-sub-head">
      <h2 className="webhooks-report-table-title">Approve Rolling Reserve Pending Settlement</h2>
      <button
  className="report-add-button"
  onClick={handleApproveAll}
  disabled={isLoading}
>
  {isLoading ? "Processing..." : "Approve All"}
</button>
</div>
      <table className="pendding-table">
        <thead>
          <tr>
            <th>Deposit Amount</th>
            <th>Merchant Name</th>
            <th>Settled By</th>
            <th>Settled Date</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan="6">Loading...</td>
            </tr>
          ) : tableData?.length > 0 ? (
            tableData
            .filter((transaction) => transaction.remark?.startsWith("ROLLING"))
            .map((transaction) => (
              <tr key={transaction.tnxId}>
                <td>₹ {Number(transaction.depositAmount).toFixed(2) || "0"}</td>
                <td>{getUserNameById(transaction.userId)}</td>
                <td>{getUserNameById(transaction.loadedBy)}</td>
                <td>
                  {new Date(transaction.createdAt).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })}{" "}
                  {new Date(transaction.createdAt).toLocaleTimeString("en-GB", {
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: true,
                  })}
                </td>
                <td>{transaction.status || "-"}</td>
                <td>
                  <button
                    className="approve-btn"
                    onClick={() => handleAction(transaction.tnxId, "SUCCESS")}
                  >
                    <FcApprove size={32} />
                  </button>
                  <button
                    className="approve-btn"
                    onClick={() => handleAction(transaction.tnxId, "FAILED")}
                  >
                    <FcDisapprove size={32} />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6">No Pending Settlement found.</td>
            </tr>
          )}
        </tbody>
      </table>

      {modalData.isOpen && (
        <Modal
          message={`Are you sure you want to mark this Settlement as ${modalData.status}?`}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      )}
      {isLoading && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default PenddingForm;
